import { ChangeEvent } from "react";
import { Col, Form, Input, Label, Row } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { Continue, DescribeYourIssue, Previous } from "../../../../Constant";
import { useAppDispatch, useAppSelector } from "../../../../Redux-Toolkit/Hooks";
import ShowError from "../../common/ShowError";
import { InquiryDetails } from "./InquiryDetails";
import { BusinessFormCommonProps } from "../../../../Type/FormLayoutType";
import { setInquiresForm } from "../../../../Redux-Toolkit/Reducers/FormLayout/FormWizardTwoSlice";

const InquiresForm = ({ callbackActive }: BusinessFormCommonProps) => {
  const { inquiresForm } = useAppSelector((state) => state.formWizardTwo);
  const { notifications, email, contactNumber, describeIssue } = inquiresForm;
  const dispatch = useAppDispatch();

  const getUserData = (event: ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    const value = name === "rememberNextTime" ? event.target.checked : event.target.value;
    dispatch(setInquiresForm({ ...inquiresForm, [name]: value }));
  };

  const handleNextButton = () => {
    if (notifications !== "" && email !== "" && contactNumber !== "" && describeIssue !== "") {
      callbackActive(4);
    } else {
      ShowError();
    }
  };

  return (
    <Form onSubmit={(event) => event.preventDefault()} className="g-3 needs-validation" noValidate>
      <Row>
        <InquiryDetails getUserData={getUserData}/>
        <Col xs="12" className="mt-2">
          <Label className="f-w-500" check>
            {DescribeYourIssue}
          </Label>
          <Input type="textarea" rows={3} value={describeIssue} name="describeIssue" onChange={getUserData} />
        </Col>
        <Col xs="12" className="text-end mt-3">
          <Btn color="primary">{Previous}</Btn>
          <Btn className="ms-1" color="primary" onClick={handleNextButton}>
            {Continue}
          </Btn>
        </Col>
      </Row>
    </Form>
  );
};

export default InquiresForm;
